import { Resource } from "../resource";

export class Brand extends Resource {
    id: string | null | undefined;
    name: string | null | undefined;
}